// Step3.jsx
import React, { useState, useEffect } from 'react';
import DateSplit from '../widgets/date';
import FileUpload from '../../../../components/FileUpload/FileUploader';
//import dissabilities from '../data/dissabilities.json';
import {
  validateDesiredDate,
  validateDocumentDate,
  validateUkrainianText,
  validateSpecializationRequired,
  validateFiles
} from '../validations/Step3';

import { getDisabilitiesList } from '../../../../services/apiClient'; 
import {loadFileAsBase64} from '../../../../services/apiClient';
import { findKgsWithInternationalAgreement } from '../activity';

const typeDocs = [
    { "name": "Довідка", "value": "1" },
    { "name": "Висновок", "value": "2" },
    { "name": "Направлення", "value": "3"}
];

const curDate = new Date();

const curYear = curDate.getFullYear();

const dissabilities = getDisabilitiesList();


const handleFileViewRequest = async (id, fileId, fileIndex) => {

  const url = `requests/${id}/file/${fileId}/dissabilities`;

  try {
    const response = await loadFileAsBase64 (url);
    return response; 
  } catch (error) {
    console.error('Ошибка загрузки файла:', error);
    throw error;
  }
};

const Step3 = ({ formData, onChange, errors }) => {

  const [hebrewKgList, setHebrewKgList] = useState([]);
  const [hebrewKgLoading, setHebrewKgLoading] = useState(false);

  const isInternationalAgreement = formData.preferences.languageTraining === 'ir';

  useEffect(() => {
    if(!isInternationalAgreement) return;
    if(hebrewKgList.length > 0) return;

    let cancelled = false;
    setHebrewKgLoading(true);

    findKgsWithInternationalAgreement()
      .then(list => { if(!cancelled) setHebrewKgList(list); })
      .catch(() => { if(!cancelled) setHebrewKgList([]); })
      .finally(() => { if(!cancelled) setHebrewKgLoading(false); });

    return () => { cancelled = true; };
  }, [isInternationalAgreement]);

  if(!getDisabilitiesList()) return null;

  return (
    <div className="form-section">
      <h2 className="form-section-title">Додаткові побажання</h2>

      <DateSplit 
        error={errors.desiredDate || errors.desiredDate} 
        date={formData.preferences.desiredDate} 
        setDate={(v)=>onChange('preferences.desiredDate', v)} 
        yearFrom={2024}  
        yearTo={curYear+5}
        label="Бажана дата вступу в садок" 
      />
      {errors.desiredDate && !errors.desiredDate && (
        <div className="invalid-feedback d-block">{errors.desiredDate}</div>
      )}

      {/* Мова навчання за міжнародною угодою */}
      <div className="form-row single">
        <div className="form-group">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="international-agreement"
              checked={isInternationalAgreement}
              onChange={(e) => onChange('preferences.languageTraining', e.target.checked ? 'ir' : 'uk')}
            />
            <label className="form-check-label" htmlFor="international-agreement">
              За міжнародною угодою (додаткове вивчення мови івриту)
            </label>
          </div>

          {isInternationalAgreement && (
            <div className="alert alert-info mt-2">
              <strong>Групи з додатковим вивченням мови івриту наявні у таких садочках:</strong>
              {hebrewKgLoading && (
                <p className="mb-0 mt-1">Завантаження переліку...</p>
              )}
              {!hebrewKgLoading && hebrewKgList.length > 0 && (
                <ul className="mb-0 mt-1">
                  {hebrewKgList.map((kg) => <li key={kg._id}>{kg.name}</li>)}
                </ul>
              )}
              {!hebrewKgLoading && hebrewKgList.length === 0 && (
                <p className="mb-0 mt-1">Не вдалося завантажити перелік садочків.</p>
              )}
              <p className="mb-0 mt-2">На наступному кроці для вибору буде доступний лише перелік цих садочків.</p>
            </div>
          )}

          {errors.languageTraining && (
            <div className="invalid-feedback d-block">{errors.languageTraining}</div>
          )}
        </div>
      </div>
      
      {/* Нова секція: Типи місць */}
      <div className="form-row single">
        <div className="form-group">
          <label className="form-label">Типи місць</label>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="place-type-without-bed"
              checked={formData.preferences.withoutBed || false}
              onChange={(e) => onChange('preferences.withoutBed', e.target.checked)}
            />
            <label className="form-check-label" htmlFor="place-type-without-bed">
              Тільки короткотривале перебування (без спального місця)
            </label>
          </div>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="place-type-not-without-bed"
              checked={formData.preferences.notWithoutBed || false}
              onChange={(e) => onChange('preferences.notWithoutBed', e.target.checked)}
            />
            <label className="form-check-label" htmlFor="place-type-not-without-bed">
              Тільки повного дня
            </label>
          </div>
          {/* Показуємо одну загальну помилку для обох полів */}
          {(errors.withoutBed || errors.notWithoutBed) && (
            <div className="invalid-feedback d-block" style={{ marginTop: '8px' }}>
              {errors.withoutBed || errors.notWithoutBed}
            </div>
          )}
        </div>
      </div>
            
      <div className="form-row single">
        <div className="form-group">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="wish-age-menu"
              checked={formData.preferences.ageMenu}
              onChange={(e) => onChange('preferences.ageMenu', e.target.checked)}
            />
            <label className="form-check-label" htmlFor="wish-age-menu">
              Бажаю відвідувати групу, меншу за віком
            </label>
          </div>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="wish-dissabilities"
              checked={formData.preferences.dissabilities}
              onChange={(e) => {onChange('preferences.dissabilities', e.target.checked)}}
            />
            <label className="form-check-label" htmlFor="wish-dissabilities">
              Спеціалізація за типом труднощів
            </label>
          </div>
        </div>
      </div>
      
      {formData.preferences.dissabilities && (
        <>
          <div className="form-row single">
            <div className="form-group">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="wish-inclusive"
                  checked={formData.preferences.inclusiveGroup}
                  onChange={(e) => onChange('preferences.inclusiveGroup', e.target.checked)}
                />
                <label className="form-check-label" htmlFor="wish-inclusive">
                  Бажаю відвідувати інклюзивну групу
                </label>
              </div>
              {errors.inclusiveGroup && <div className="invalid-feedback">{errors.inclusiveGroup}</div>}
              
                <div className="form-row single">
          <div className="form-group">
            {false && formData.preferences.inclusiveGroup  && (
              <div className="alert alert-info">
                <strong>Перелік видів захворювань, за якими передбачено створення місць інклюзивного типу:</strong>
                <p>
                  { false && ["58fdc4708e78266a9d926b65","58fdc47d8e78266a9d926b66","58fdc48f8e78266a9d926b67","58fdc49c8e78266a9d926b68","58fdc4a98e78266a9d926b69","58fdc4b48e78266a9d926b6a","593009177ed0bdb13cc331c3","58fdc4618e78266a9d926b64"].map((id, index)=><div>{index + 1}. {dissabilities.filter(r=>r._id == id)[0].name}.</div>)}
                </p>
                <p>
                  <strong>Чи можу я подати заявку з іншими типами захворювань?</strong><br />
                  Так, але в цьому випадку зніміть позначку щодо обрання групи з інклюзивним типом місць.
                </p>
              </div>)}
        
          </div>
        </div>
            </div>
          </div>
          
          <div className="form-row single">
            <div className="form-group">
              <label className="form-label">Тип труднощів *</label>
              <select
                id="select-dissabilities"
                className={`form-select ${errors.diseaseType || errors.diseaseType ? 'is-invalid' : ''}`}
                value={formData.preferences.diseaseType}
                onChange={(e) => onChange('preferences.diseaseType', e.target.value)}
              >
                {<option value="">Оберіть тип труднощів</option>}
                {getDisabilitiesList()?.map(r=><option key={r._id} value={r._id}>{r.label}</option>)}
              </select>
              {errors.diseaseType && <div className="invalid-feedback">{errors.diseaseType}</div>}
              {errors.diseaseType && !errors.diseaseType && (
                <div className="invalid-feedback d-block">{errors.diseaseType}</div>
              )}
            </div>
          </div>
          
          {formData.preferences.diseaseType && (
            <>
              <div className="form-row two-cols">
                <div className="form-group">
                  <label className="form-label">Тип документа *</label>
                  <select
                    className={`form-select ${errors.diseaseDocumentType || errors.documentType ? 'is-invalid' : ''}`}
                    value={formData.preferences.diseaseDocument.type}
                    onChange={(e) => onChange('preferences.diseaseDocument.type', e.target.value)}
                  >
                    <option value="">Обраний документ</option>
                    {typeDocs.map(r=><option key={r.value} value={r.value}>{r.name}</option>)}
                  </select>
                  {errors.diseaseDocumentType && <div className="invalid-feedback">{errors.diseaseDocumentType}</div>}
                  {errors.documentType && !errors.diseaseDocumentType && (
                    <div className="invalid-feedback d-block">{errors.documentType}</div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Номер документа *</label>
                  <input
                    type="text"
                    className={`form-control ${errors.diseaseDocumentNumber || errors.documentNumber ? 'is-invalid' : ''}`}
                    placeholder=""
                    value={formData.preferences.diseaseDocument.number}
                    onChange={(e) => onChange('preferences.diseaseDocument.number', e.target.value)}
                  />
                  {errors.diseaseDocumentNumber && <div className="invalid-feedback">{errors.diseaseDocumentNumber}</div>}
                  {errors.documentNumber && !errors.diseaseDocumentNumber && (
                    <div className="invalid-feedback d-block">{errors.documentNumber}</div>
                  )}
                </div>
              </div>
              
              <div className="form-row single">
                <div className="form-group">
                  <label className="form-label">Кому видано *</label>
                  <input
                    type="text"
                    className={`form-control ${errors.diseaseDocumentIssuedTo || errors.issuedTo ? 'is-invalid' : ''}`}
                    placeholder=""
                    value={formData.preferences.diseaseDocument.issuedTo}
                    onChange={(e) => onChange('preferences.diseaseDocument.issuedTo', e.target.value)}
                  />
                  {errors.diseaseDocumentIssuedTo && <div className="invalid-feedback">{errors.diseaseDocumentIssuedTo}</div>}
                  {errors.issuedTo && !errors.diseaseDocumentIssuedTo && (
                    <div className="invalid-feedback d-block">{errors.issuedTo}</div>
                  )}
                </div>
              </div>
              
              <DateSplit 
                error={errors.diseaseDocumentDate || errors.documentDate} 
                date={formData.preferences.diseaseDocument.issueDate} 
                setDate={(v)=>onChange('preferences.diseaseDocument.issueDate', v)} 
                yearFrom={2017}  
                yearTo={curYear} 
                label="Дата видачі *" 
              />
              {errors.documentDate && !errors.diseaseDocumentDate && (
                <div className="invalid-feedback d-block">{errors.documentDate}</div>
              )}
              
              <FileUpload
                label='Завантажте фото чи скан-копію документа'  
                value={formData.preferences.diseaseDocument.files} 
                onChange={(files)=>onChange('preferences.diseaseDocument.files', files)} 
                onBlur={(files)=>onChange('preferences.diseaseDocument.files', files)} 
                onFocus={(files)=>onChange('preferences.diseaseDocument.files', files)}
                multiple={true}
                errorVal={errors.diseaseDocumentFiles}
                maxSize={5 * 1024 * 1024}
                description='Один або кілька файлів у форматі PDF, JPG, PNG. Максимальний розмір файлу 5 МБ.'
                onFileViewRequest={(fileId, fileIndex)=>handleFileViewRequest(formData._id, fileId, fileIndex)}
              />
              {errors.files && !errors.diseaseDocumentFiles && (
                <div className="invalid-feedback d-block">{errors.files}</div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Step3;